import { registerPlugin } from "@capacitor/core";

// Native side:
//   Android: android/app/src/main/java/app/the99/VideoTrimPlugin.java (MediaMuxer, lossless)
//   iOS:     ios-prep/VideoTrimPlugin.swift (AVAssetExportSession) — wired when the iOS project exists
// Web fallback: rejects so non-native builds can import safely; callers fall back to
// uploading the full clip and recording the trim as audit-only metadata.
const VideoTrim = registerPlugin("VideoTrim", {
  web: () => ({
    trim: async () => {
      throw new Error("VideoTrim: native only");
    },
  }),
});

export default VideoTrim;
